import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { BottomNav } from './BottomNav';
import type { AdminUser } from '../types';
import type { View } from '../lib/views';
import type { PipColor } from './NavPip';

interface Props {
  user: AdminUser;
  view: View;
  setView: (v: View) => void;
  /** Slots optionnels pour piloter les count/pips de la sidebar par view. */
  slotsByView?: Partial<Record<View, { count?: number; pip?: { color: PipColor; label?: string } }>>;
  pendingChanges: number;
  draftNewsCount?: number;
  section: string;
  onPublished?: () => void;
  onSearchClick?: () => void;
  children: ReactNode;
}

export function Layout({
  user, view, setView, slotsByView, pendingChanges, draftNewsCount,
  section, onPublished, onSearchClick, children,
}: Props) {
  return (
    <div className="flex min-h-screen">
      <Sidebar view={view} setView={setView} user={user} slotsByView={slotsByView} />
      <main
        className="flex-1 min-w-0"
        style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 64px)' }}
      >
        <Topbar section={section} pendingChanges={pendingChanges} onPublished={onPublished} onSearchClick={onSearchClick} />
        {children}
      </main>
      <BottomNav view={view} setView={setView} pendingChanges={pendingChanges} draftNewsCount={draftNewsCount} />
    </div>
  );
}
